import n from "./_cloneArrayBuffer.js";
function t(r, f) {
  var e = f ? n(r.buffer) : r.buffer;
  return new r.constructor(e, r.byteOffset, r.byteLength);
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cloneDataView.js
// module id = 1498
// module chunks = 67